var options = [
  {
    value: 'option 1',
    label: 'Option 1'
  },
  {
    value: 'option 2',
    label: 'Option 2'
  },
  {
    value: 'fruits',
    label: 'Fruits',
    options: [
      {
        value: 'citrus',
        label: 'Citrus',
        options: [
          {
            value: 'orange',
            label: 'Orange',
          },
          {
            value: 'grapefruits',
            label: 'GrapeFruits',
          },
          {
            value: 'limes',
            label: 'Limes',
          },
          {
            value: 'mandarins',
            label: 'Mandarins',
          },
        ],
      },
      {
        value: 'tropical',
        label: 'Tropical',
        options: [
          {
            value: 'mango',
            label: 'Mango',
          },
          {
            value: 'papaya',
            label: 'Papaya',
          },
          {
            value: 'pomegranate',
            label: 'Pomegranate',
          },
          {
            value: 'guava',
            label: 'Guava',
          },
        ],
      },
      {
        value: 'berries',
        label: 'Berries',
        options: [
          {
            value: 'strawberry',
            label: 'Strawberry',
          },
          {
            value: 'raspberries',
            label: 'Raspberries',
          },
          {
            value: 'blueberries',
            label: 'Blueberries',
          },
          {
            value: 'kiwifruit',
            label: 'Kiwifruit',
          },
          {
            value: 'passionfruit',
            label: 'PassionFruit',
          },
        ],
      },
      {
        value: 'apple',
        label: 'Apple',
      },
      {
        value: 'banana',
        label: 'Banana',
      }
    ],
  },
  {
    value: 'city',
    label: 'City',
    options: [
      {
        value: 'delhi',
        label: 'Delhi',
        options: [
          {
            value: 'north delhi',
            label: 'North Delhi',
            options: [
              {
                value: 'malikpur chawni',
                label: 'Malikpur Chawni',
              },
              {
                value: 'narela',
                label: 'Narela',
              },
              {
                value: 'khera kalan',
                label: 'Khera Kalan',
              },
            ],
          },
          {
            value: 'south delhi',
            label: 'South Delhi',
            options: [
              {
                value: 'rai pithora',
                label: 'Rai Pithora',
              },
              {
                value: 'mehrauli',
                label: 'Mehrauli',
              },
              {
                value: 'siri',
                label: 'Siri',
              },
            ],
          },
          {
            value: 'west delhi',
            label: 'West Delhi',
            options: [
              {
                value: 'patel nagar',
                label: 'Patel Nagar',
              },
              {
                value: 'rajouri garden',
                label: 'Rajouri Garden',
              },
              {
                value: 'punjabi bagh',
                label: 'Punjabi Bagh',
              },
            ],
          },
        ],
      },
      {
        value: 'bangalore',
        label: 'Bangalore',
        options: [
          {
            value: 'banashankari',
            label: 'Banashankari',
            options: [
              {
                value: '1st stage',
                label: '1st Stage',
                options: [
                  {
                    value: 'hanumanthanagar',
                    label: 'Hanumanthanagar',
                  },
                  {
                    value: 'srinagar',
                    label: 'Srinagar',
                  },
                  {
                    value: 'srinagar',
                    label: 'Srinagar',
                  },
                  {
                    value: 'brindavan nagar',
                    label: 'Brindavan Nagar',
                  },
                ]
              },
              {
                value: '2nd stage',
                label: '2nd Stage',
                options: [
                  {
                    value: 'kadirenahalli',
                    label: 'Kadirenahalli',
                  },
                  {
                    value: 'teachers colony',
                    label: 'Teachers Colony',
                  },
                  {
                    value: 'yarab nagar',
                    label: 'Yarab Nagar',
                  },
                  {
                    value: 'karesandra',
                    label: 'Karesandra',
                  },
                ]
              },
              {
                value: '3rd stage',
                label: '3rd Stage',
                options: [
                  {
                    value: 'hosakerehalli',
                    label: 'Hosakerehalli',
                  },
                  {
                    value: 'kathriguppe',
                    label: 'Kathriguppe',
                  },
                  {
                    value: 'channammanakere',
                    label: 'Channammanakere',
                  },
                  {
                    value: 'kamakya layout',
                    label: 'Kamakya layout',
                  },
                ]
              }
            ]
          },
          {
            value: 'koramangala',
            label: 'Koramangala',
            options: [
              {
                value: '1st block',
                label: '1st Block',
              },
              {
                value: '2nd block',
                label: '2nd Block',
              },
              {
                value: 'jakasandra block',
                label: 'Jakasandra Block',
              },
            ]
          },
          {
            value: 'hebbal',
            label: 'Hebbal',
          },
          {
            value: 'jayanagar',
            label: 'Jayanagar',
          }
        ]
      },
    ],
  },
];

export default options;
